import { Property } from './interfaces';

export const unidadMedida: Property = {
  title: 'Unidad de Medida',
  type: 'integer',
};
